import React from 'react';
import {Card, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card';
import Chip from 'material-ui/Chip';

const styles = {
  card:{
    margin:8,
  },
  cardheader:{
    padding:8,
    paddingBottom:0,
  },
  imgStyle:{
    //height:350,
  },
  maintext:{
    paddingTop:0,
    paddingBottom:0,
  },
  chip: {
    margin: 4,
    backgroundColor:"rgb(240,240,240)"
  },
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap',
  },
};

export default class ExperienceMaxTimer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
  }

  handleExpandChange = (expanded) => {
    this.setState({expanded: expanded});
  };

  handleToggle = (event, toggle) => {
    this.setState({expanded: toggle});
  };

  handleExpand = () => {
    this.setState({expanded: true});
  };

  handleReduce = () => {
    this.setState({expanded: false});
  };

  render() {
    return (
      <Card
        expanded={this.state.expanded}
        onExpandChange={this.handleExpandChange}
        style={styles.card}
      >
        <CardHeader
          title="MaxTimer, Sole Developer"
          subtitle="Race Timing Software: 2020-present"
          avatar="images/maxtimer.jpg"
          actAsExpander={true}
          showExpandableButton={this.props.showCarrot}
          style={styles.cardheader}
        />
        <CardText
          style={styles.maintext}
        >

          <div>
            <ul>
              <li>
                Design and development of race timing software
              </li>
              <div style={styles.wrapper}>
                <Chip style={styles.chip}>
                  Electron
                </Chip>
                <Chip style={styles.chip}>
                  React
                </Chip>
                <Chip style={styles.chip}>
                  Next.js (Vercel)
                </Chip>
                <Chip style={styles.chip}>
                  PouchDB
                </Chip>
                <Chip style={styles.chip}>
                  Firebase Authentication
                </Chip>
                <Chip style={styles.chip}>
                  Amazon Appsync (GraphQL)
                </Chip>
              </div>
            </ul>

          </div>
        </CardText>
        <CardMedia
          expandable={true}
          overlay={<CardTitle title="MaxTimer" subtitle="" />}
        >
          <img
            src="images/maxtimer-screen.jpg" alt=""
            style={styles.imgStyle}
          />
        </CardMedia>
        <CardText expandable={true}>
          <ul>
            <li>MaxTimer is timing software for autocrossers under development</li>
            <li>Desktop Application (Electron/PouchDB) with live online results (Next.js/Vercel)</li>
          </ul>
        </CardText>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ExperienceMaxTimer.js